import type { GoalCardProps } from './types'
import { CardContainer, CardTitle, ValueWrapper } from '../common/styles'
import { ProgressRow } from '../ProgressRow'
import { ProgressContainer, ProgressBar, ValueText } from '../ProgressRow/styles'
import {
  NEUTRAL_COLOR,
  getProgressColor,
  calculatePercentage
} from '../common/utils'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import {
  FUTURE_SALES_MESSAGE,
  getDisabledFieldMessage,
  isFieldDisabled
} from 'utils/reportDisabledFields'
import { formatValue } from '../ProgressRow/utils'

export const GoalCard = ({
  disabledReason,
  valueDisabledReason,
  title,
  value = 0,
  expectedValue = 0
}: GoalCardProps) => {
  const disabled = isFieldDisabled(disabledReason)
  const valueDisabled = isFieldDisabled(valueDisabledReason)
  const percentage = disabled || valueDisabled
    ? 0
    : calculatePercentage(value, expectedValue)
  const progressColor = disabled || valueDisabled
    ? NEUTRAL_COLOR
    : getProgressColor(percentage)

  return (
    <CardContainer>
      <CardTitle>{title}</CardTitle>
      {disabled
        ? (
          <BootstrapTooltip title={getDisabledFieldMessage(disabledReason)}>
            <ValueWrapper>-</ValueWrapper>
          </BootstrapTooltip>
          )
        : valueDisabled
          ? (
            <div>
              <ProgressContainer>
                <ValueText small>{formatValue(expectedValue, 'currency')}</ValueText>
                <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
                  <ValueText small color={progressColor}>-</ValueText>
                </BootstrapTooltip>
              </ProgressContainer>
              <ProgressBar small progresscolor={progressColor} value={0} />
            </div>
            )
        : (
          <ProgressRow
            small
            leftValue={expectedValue}
            leftFormat="currency"
            rightValue={percentage}
            rightFormat="percentage"
            rightColor={progressColor}
            progressValue={percentage}
            progressColor={progressColor}
          />
          )}
    </CardContainer>
  )
}
